import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 106,
	height: 97,
	viewBox: "0 0 106 97",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.4688 96.1406H92.4922C100.656 96.1406 105.578 90.4375 105.578 83.2109C105.578 80.8672 104.914 78.4453 103.625 76.2188L64.1328 7.15625C61.6719 2.82031 57.3359 0.671875 53 0.671875C48.625 0.671875 44.3281 2.82031 41.8672 7.15625L2.375 76.2188C1.04688 78.4844 0.421875 80.8672 0.421875 83.2109C0.421875 90.4375 5.34375 96.1406 13.4688 96.1406ZM53 62.7031C50.7344 62.7031 49.4844 61.375 49.4453 59.0312L48.8203 31.5312C48.7812 29.1875 50.5 27.5078 52.9609 27.5078C55.3828 27.5078 57.1406 29.2266 57.1016 31.5703L56.4766 59.0312C56.4375 61.4141 55.1484 62.7031 53 62.7031ZM53 78.9922C50.2266 78.9922 47.8828 76.7656 47.8828 74.0703C47.8828 71.3359 50.1875 69.1094 53 69.1094C55.7734 69.1094 58.1172 71.2969 58.1172 74.0703C58.1172 76.8047 55.7344 78.9922 53 78.9922Z",
		fill: "#BFBFBF"
	})
});
export default SvgWarning;
